/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveUsersAnalytics,
  AzureAppUptimeResponse,
  CompassAnalyticsResponse,
  EmergencyAnalyticsResponse,
  WeeklyUserAnalyticsResponse,
} from '../models/index';
import {
    ActiveUsersAnalyticsFromJSON,
    ActiveUsersAnalyticsToJSON,
    AzureAppUptimeResponseFromJSON,
    AzureAppUptimeResponseToJSON,
    CompassAnalyticsResponseFromJSON,
    CompassAnalyticsResponseToJSON,
    EmergencyAnalyticsResponseFromJSON,
    EmergencyAnalyticsResponseToJSON,
    WeeklyUserAnalyticsResponseFromJSON,
    WeeklyUserAnalyticsResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI {

    /**
     */
    async apiAnalyticsGetActiveUsersByOrgGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActiveUsersAnalytics>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Analytics/GetActiveUsersByOrg`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActiveUsersAnalyticsFromJSON));
    }

    /**
     */
    async apiAnalyticsGetActiveUsersByOrgGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActiveUsersAnalytics>> {
        const response = await this.apiAnalyticsGetActiveUsersByOrgGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAnalyticsGetAzureAppUptimeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AzureAppUptimeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Analytics/GetAzureAppUptime`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AzureAppUptimeResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAnalyticsGetAzureAppUptimeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AzureAppUptimeResponse> {
        const response = await this.apiAnalyticsGetAzureAppUptimeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAnalyticsGetCompassDeviceUseByOrgGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompassAnalyticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Analytics/GetCompassDeviceUseByOrg`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompassAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAnalyticsGetCompassDeviceUseByOrgGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompassAnalyticsResponse> {
        const response = await this.apiAnalyticsGetCompassDeviceUseByOrgGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAnalyticsGetEmergenciesByOrgGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyAnalyticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Analytics/GetEmergenciesByOrg`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAnalyticsGetEmergenciesByOrgGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyAnalyticsResponse> {
        const response = await this.apiAnalyticsGetEmergenciesByOrgGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAnalyticsGetWeeklyUserStatsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeeklyUserAnalyticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Analytics/GetWeeklyUserStats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeeklyUserAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAnalyticsGetWeeklyUserStatsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeeklyUserAnalyticsResponse> {
        const response = await this.apiAnalyticsGetWeeklyUserStatsGetRaw(initOverrides);
        return await response.value();
    }

}
